import template from './privilege-template-confirmation-dialog.html';

export default class PrivilegeTemplateConfirmationDialogComponent {
  constructor() {
    this.template = template;
    this.bindings = {
      resolve: '<',
      close: '&',
      dismiss: '&',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/components/privilege-template-confirmation-dialog/privilege-template-confirmation-dialog-component.js